import type { ElementType } from 'react'

import { useContext } from 'react'

import { DiscardDialogContext } from './context'

export function withDiscardDialog<T extends object> (Component: ElementType) {
  return function WithDiscardDialog (props: T): JSX.Element {
    let discardDialog = useContext(DiscardDialogContext)

    return (
      <Component
        discardDialog={discardDialog}
        {...props}
      />
    )
  }
}

export { DiscardDialogContext }
